var chunkToChildrenMap = {
	"1480": [
		6989,
		4135,
		2059,
		4580
	],
	"5999": [
		6989,
		2823,
		1411,
		1480
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};